import React from "react";

const Footer = () => {
  return (
    <footer>
      <p class="footer-text">Designed and Developed by Ihtisham Ul Haq</p>
      <p id="footer" class="footer-text">
        CodingTech &copy; Inc. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
